import React from 'react';
import { Typography } from '@material-ui/core';
import { ColumnProps } from 'components/@common/Table/LwtTable';
import {
  appendSecondsOrFallback,
  getDefaultText
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import { TFunction } from 'i18next';
import ReportLink from 'components/ReportsModule/components/common/ReportLink';
import { ReportEntityType } from 'components/ReportsModule/types';

const Title = ({ children }: any) => (
  <Typography style={{ fontSize: 12, fontWeight: 600 }}>{children}</Typography>
);

const getSingleStudentModuleColumns: (t: TFunction, tUpper: TFunction) => ColumnProps<any>[] = (
  t: TFunction,
  tUpper
) => {
  const main: ColumnProps<any> = {
    id: 'studentName    ',
    label: <Title>{tUpper('Student')}</Title>,
    sortKey: 'studentName',
    getValue: item => (
      <ReportLink
        key={item?.studentId}
        entityType={ReportEntityType.STUDENT}
        entityId={item?.studentId}
      >
        {item.studentName}
      </ReportLink>
    ),
    sortable: true
  };

  return [
    main,
    {
      id: 'timePerQuestion',
      label: <Title>{tUpper('Avg Time Per Question')}</Title>,
      sortKey: 'timePerQuestion',
      getValue: item => <Typography>{appendSecondsOrFallback(item.timePerQuestion)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfQuestionsCompleted',
      label: <Title>{tUpper('Questions Completed')}</Title>,
      sortKey: 'noOfQuestionsCompleted',
      getValue: item => <Typography>{getDefaultText(item.noOfQuestionsCompleted)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfTries',
      label: <Title>{tUpper('Avg Tries Per Question')}</Title>,
      sortKey: 'noOfTries',
      getValue: item => <Typography>{getDefaultText(item.noOfTries)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfQuestion',
      label: <Title>{tUpper('Questions Answered In One Try')}</Title>,
      sortKey: 'noOfQuestion',
      getValue: item => <Typography>{item.noOfQuestion ?? '-'}</Typography>,
      sortable: true
    }
  ];
};

export default getSingleStudentModuleColumns;
